import { Action } from 'redux';
// Import States.
import {
	AppState,
	EndorsementState,
} from '@app/redux/states';
// Import Actions.
import {
	LoadAllowedEndorsementDateRangeAction,
} from '@app/redux/actions';
// Import state initializers.
import {
	initializeEndorsementState
} from '@app/redux/reducers/initializers';
// Import state queries.
import {
	queryEndorsementState,
} from '@app/redux/reducers/queries';
// Import api models.
import {
    AllowedEndorsementDateRange,
} from '@app/models/api';


// Load Allowed Endorsement Date Range Reducer.

let LoadAllowedEndorsementDateRangeReducer = (state: AppState, action: Action): AppState => {
	let loadAllowedEndorsementDateRangeAction: LoadAllowedEndorsementDateRangeAction = action as LoadAllowedEndorsementDateRangeAction;
	let allowedEndorsementDateRange: AllowedEndorsementDateRange = loadAllowedEndorsementDateRangeAction.allowedEndorsementDateRange;

	// Create copy of the of app state.
	let newState: AppState = initializeEndorsementState(state, loadAllowedEndorsementDateRangeAction);

	// Query the state.
	let endorsementState: EndorsementState = queryEndorsementState(newState, loadAllowedEndorsementDateRangeAction);

	endorsementState.allowedEndorsementDateRange = allowedEndorsementDateRange;

	return newState;
}


// Export reducers.
export {
	LoadAllowedEndorsementDateRangeReducer,
};